import { findAllPermissions } from '@src/main/modules/roles/application/find-all-permissions.usecase';
import { PermissionRepository } from '@src/main/modules/roles/domain/permission.repository';
import { createPermissionHttpRepository } from '@src/main/modules/roles/infrastructure/PermissionHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useQuery } from '@tanstack/react-query';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const usePermissions = () => {
  const { user } = useAuth();
  const [repository, setRepository] = useState<PermissionRepository | null>(null);

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  useEffect(() => {
    if (user?.token) {
      const repo = createPermissionHttpRepository(tokenProvider);
      setRepository(repo);
    } else {
      setRepository(null);
    }
  }, [user?.token, tokenProvider]);

  const queryResult = useQuery({
    queryKey: ['permission'],
    queryFn: async () => {
      if (!repository) throw new Error('Repository not available');
      return await findAllPermissions(repository);
    },
    enabled: !!repository,
    staleTime: 1000 * 60,
  });

  return { ...queryResult, repository };
};
